export {
  default as PaletteStyleTag,
  type PaletteStyleTagProps,
} from './PaletteStyleTag';
export type { Themes } from './types/themes';
